import { useRef } from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { Button, DialogBody, DialogFooter, DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { usePersistBuildForm } from '../hook/usePersistBuildForm';
export const ContinueBuildConfirmModal = ({
  timeStamp,
  quizTitle,
  onCancel,
  onConfirm
}: {
  timeStamp: number;
  quizTitle: string;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  return <ResponsiveDialog size="xs" shouldCloseOnDimClick={false} data-sentry-element="ResponsiveDialog" data-sentry-component="ContinueBuildConfirmModal" data-sentry-source-file="ContinueBuildConfirmModal.tsx">
      <DialogHeader className="text-heading-md-bold text-default" title={t('build.autoSave.noticeTitle')} hasCloseButton={false} data-sentry-element="DialogHeader" data-sentry-source-file="ContinueBuildConfirmModal.tsx" />
      <DialogBody className="flex flex-col gap-xs px-lg" data-sentry-element="DialogBody" data-sentry-source-file="ContinueBuildConfirmModal.tsx">
        <div className="text-body-md-regular">
          {t('build:autoSave.confirm')}
        </div>
        <div className="flex flex-col justify-center gap-sm rounded-[8px] bg-neutral px-sm py-[16px]">
          <div className={'flex flex-col gap-[3px]'}>
            <div className={'text-caption-lg-semibold  text-gray-600'}>
              {t('build:build.autoSave.quizSavedTime')}
            </div>
            <div className={'text-body-md '}>
              {format(timeStamp, 'yyyy-MM-dd HH:mm:ss')}
            </div>
          </div>
          <div className={'flex flex-col gap-[3px]'}>
            <div className={'text-caption-lg-semibold  text-gray-600'}>
              {t('build.autoSave.quizTitle')}
            </div>
            <div className={'text-body-md'}>
              {quizTitle || t('build.autoSave.emptyTitle')}
            </div>
          </div>
        </div>
      </DialogBody>
      <DialogFooter className="flex flex-row justify-center gap-xs" data-sentry-element="DialogFooter" data-sentry-source-file="ContinueBuildConfirmModal.tsx">
        <Button className="flex-1 grow" variant={'contained'} intent="neutral" size="md" onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="ContinueBuildConfirmModal.tsx">
          {t('common:global.cancel.button')}
        </Button>
        <Button className="flex-1 grow" variant={'contained'} intent="strong" size="md" onClick={onConfirm} data-sentry-element="Button" data-sentry-source-file="ContinueBuildConfirmModal.tsx">
          {t('build:build.autoSave.writeNext')}
        </Button>
      </DialogFooter>
    </ResponsiveDialog>;
};
export const useOpenContinueBuildConfirmModal = () => {
  const isOpened = useRef(false);
  const {
    persistData
  } = usePersistBuildForm();
  const open = async () => {
    isOpened.current = true;
    const confirmed = await overlay.openAsync<boolean>(({
      unmount,
      close
    }) => <ContinueBuildConfirmModal timeStamp={persistData.timeStamp} quizTitle={persistData.data?.title ?? ''} onCancel={() => {
      unmount();
      close(false);
    }} onConfirm={() => {
      unmount();
      close(true);
    }} />);
    isOpened.current = false;
    return confirmed;
  };
  return {
    open,
    isOpened
  };
};